import React, { useEffect, useRef, useState } from "react";
import icon_allgames from "~/images/icon_All.png";
import icon_arcade from "~/images/icon_Arcade.png";
import icon_board from "~/images/icon_Board.png";
import icon_card from "~/images/icon_Card.png";
import icon_fishing from "~/images/icon_Fishing.png";
import icon_slot from "~/images/icon_Slot.png";
import styled, { ThemeProvider } from "styled-components";
import { prop } from "styled-tools";
import "../styles/custom.css";
import Fade from 'react-reveal/Fade';

const WrapperGameDemo = styled.div`
  padding: 15px;
`;

const Header = styled.div`
  text-align: left;
  font-size: 80px;
  letter-spacing: 0px;
  color: ${(props) => props.color};
  text-shadow: inset 0px 1px 6px #00000029;
  text-transform: uppercase;
  margin: 40px 0px;
  opacity: 1;
  font-weight: bold;
  font-family: "Kanit", sans-serif;

  @media screen and (max-width: 1200px) {
    font-size: 50px;
    font-weight: bold;
    margin: 30px 20px;
  }

  @media screen and (max-width: 976px) {
    font-size: 40px;
    font-weight: bold;
    margin: 20px 10px;
  }
`;

const Nav = styled.nav`
  position: relative;
  display: flex;
  justify-content: start;

  img {
    width: 38px;
    height: 30px;

    @media screen and (max-width: 1200px) {
      width: 28px;
      height: 20px;
    }
  }

  button {
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: inset 5px 3px 13px -9px #747171, 5px 5px 10px #ffffff;
    border: 0.10000000149011612px solid #00000003;
    border-radius: 40px;
    width: 200px;
    height: 60px;
    margin: 0 5px;
    font-size: 25px;
    color: ${(props) => props.color};
    text-decoration: none;
    cursor: pointer;

    &.-active {
      background: ${(props) => props.buttonTheme};
      box-shadow: -5px -5px 10px #ffffff;
      border-radius: 40px;
      color: #ffffff;
      opacity: 1;
    }

    @media screen and (max-width: 1200px) {
      width: 150px;
      height: 50px;
      font-size: 20px;
    }

    @media screen and (max-width: 976px) {
      font-size: 14px;
      width: 120px;
      height: 40px;
    }

    @media screen and (max-width: 768px) {
      display: flex;
      justify-content: center;
      font-size: 0px;
      width: 50px;
      height: 50px;
      border: 180px;
      margin-right: 10px;
    }
  }

  #marker {
    position: absolute;
    display: flex;
    justify-content: center;
    left: 20px;
    width: 160px;
    height: 4px;
    bottom: -30px;
    transition: 0.5s;

    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  .trigle {
    width: 0;
    height: 0;
    border-left: 30px solid transparent;
    border-right: 30px solid transparent;
    border-bottom: 15px solid ${prop("color")};
    opacity: 1;

    ::before {
      content: "";
      box-shadow: inset 10px 10px 15px #00000033;
      border-left: 40px solid transparent;
      border-right: 40px solid transparent;
      border-bottom: 20px solid #00000033;
      position: absolute;
      -webkit-transform: translate(-49px, -15px);
      -ms-transform: translate(-49px, -15px);
      transform: translate(-40px, -5px);
      z-index: -1;
    }
  }
`;

const WrapperGame = styled.div`
  width: 100%;
  height: fit-content;
  box-shadow: inset 15px 13px 13px -9px #00000033, inset -5px -13px 20px #ffffff;
  border: 0.10000000149011612px solid #70707003;
  padding: 20px 0px;
  color: ${(props) => props.color};
`;

const WrapperGameFrame = styled.div`
  width: 100%;
  height: 500px;
  box-shadow: inset 15px 13px 13px -9px #00000033, inset -5px -13px 20px #ffffff;
  border: 0.10000000149011612px solid #70707003;
  color: ${(props) => props.color};

  iframe {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 820px) {
    height: 443px;
  }

  @media screen and (max-width: 768px) {
    height: 400px;
  }

  @media screen and (max-width: 420px) {
    transform: rotate(90deg) translate(50px,17%);
    margin-bottom: 95px;
    width: 465px;
    height: 335px;

    iframe {
      width: 100%;
      height: 335px;
    }
  }
`;

const WrapperGameFramePgSlot = styled.div`
  width: 100%;
  height: 768px;
  box-shadow: inset 15px 13px 13px -9px #00000033, inset -5px -13px 20px #ffffff;
  border: 0.10000000149011612px solid #70707003;
  color: ${(props) => props.color};

  iframe {
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 420px) {
    height: 600px;
  }
`;

const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 196px;
  height: 52px;
  background: #e8e8e0 0% 0% no-repeat padding-box;
  box-shadow: -5px -5px 10px #ffffff99, 10px 4px 31px #838383;
  border-radius: 26px;
  padding: 3px;
  margin: 10px auto;
  user-select: none;

  @media screen and (max-width: 1200px) {
    width: 135px;
    height: 35px;
  }

  @media screen and (max-width: 640px) {
    width: 115px;
    height: 25px;
  }
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 186px;
  height: 42px;
  background: ${(props) => props.theme.background};
  border: ${(props) => props.theme.border};
  border-radius: 26px;
  opacity: 1;
  color: ${(props) => props.theme.color};
  text-transform: capitalize;

  &:hover {
    color: ${(props) => props.theme.hover.color};
    background: ${(props) => props.theme.hover.background};
    transition: 500ms linear;
  }

  @media screen and (max-width: 1200px) {
    width: 130px;
    height: 30px;
  }

  @media screen and (max-width: 640px) {
    font-size: 10px;
    width: 110px;
    height: 20px;
  }
`;

const textColorTheme = {
  live22: {
    color: "#0396FF",
  },
  slotxo: {
    color: "#E40203",
  },
  pgslot: {
    color: "#3DB741",
  },
  joker: {
    color: "#FF12A4",
  },
  ambslot: {
    color: "#FFB503",
  },
};

const trigleTheme = {
  live22: {
    borderbottom: "#0396ff",
  },
  slotxo: {
    borderbottom: "#E40203",
  },
  pgslot: {
    borderbottom: "#E40203",
  },
  joker: {
    borderbottom: "#E40203",
  },
  ambslot: {
    borderbottom: "#FFB503",
  },
};

const ButtonTheme = {
  live22: {
    color: "#0396FF",
    background: "#e8e8e0 0% 0% no-repeat padding-box",
    hover: {
      color: "#ffffff",
      background:
        "transparent linear-gradient(180deg, #0396FF 0%, #0080DB 100%) 0% 0% no-repeat padding-box",
    },
    border: "2px solid #0396FF",
    borderBottom: "15px solid #0396ff",
  },
  slotxo: {
    color: "#E40203",
    background: "#e8e8e0 0% 0% no-repeat padding-box",
    hover: {
      color: "#ffffff",
      background:
        "transparent linear-gradient(180deg, #E40203 0%, #960E10 100%) 0% 0% no-repeat padding-box",
    },
    border: "2px solid #E40203",
    borderBottom: "15px solid #0396ff",
  },
  pgslot: {
    color: "#28BC7B",
    background: "#e8e8e0 0% 0% no-repeat padding-box",
    hover: {
      color: "#ffffff",
      background:
        "transparent linear-gradient(180deg, #28BC7B 0%, #3DB741 100%) 0% 0% no-repeat padding-box",
    },
    border: "2px solid #28BC7B",
    borderBottom: "15px solid #28BC7B",
  },
  joker: {
    color: "#FF12A4",
    background: "#e8e8e0 0% 0% no-repeat padding-box",
    hover: {
      color: "#ffffff",
      background:
        "transparent linear-gradient(180deg, #FF12A4 0%, #DA0055 100%) 0% 0% no-repeat padding-box",
    },
    border: "2px solid #FF12A4",
    borderBottom: "15px solid #FF12A4",
  },
  ambslot: {
    color: "#FFB503",
    background: "#e8e8e0 0% 0% no-repeat padding-box",
    hover: {
      color: "#ffffff",
      background:
        "transparent linear-gradient(180deg, #E59801 0%, #E59801 100%) 0% 0% no-repeat padding-box",
    },
    border: "2px solid #FFB503",
    borderBottom: "15px solid #FFB503",
  },
};

const GameDemoComponent = ({
  location,
  lazyData,
  load,
  skip,
  perPage,
  renderData,
  setCurrentType,
  listCate,
}) => {
  const [select, setSelect] = useState("all");
  const [isLaunchDemo, setIsLaunchDemo] = useState(false);
  const [urlIframe, setUrlIframe] = useState();
  const [isLoading, setIsLoading] = useState(false);
  // const [count, setCount] = useState(0);
  // console.log('count: ', count);
  const ref = useRef(0)
  const onClickMenu = (value) => [setSelect(value), setCurrentType(value)];

  useEffect(() => {
    event();
  });

  const event = () => {
    if (typeof window !== `undefined`) {
      const marker = document.getElementById("marker");
      const item = document.querySelectorAll("button");
      item.forEach((link) => {
        link.addEventListener("click", (e) => {
          indicator(e.target);
        });
      });

      const indicator = (e) => {
        marker.style.left = e.offsetLeft + "px";
        marker.style.width = e.offsetWidth + "px";
      };
    }
  };

  const openGameDemo = async (items) => {
    setIsLaunchDemo(true);
    setIsLoading(true);
    const param = {
      gameId: items.gameId,
      provider: items.provider,
      backLink: location === '/live22' ? "https://kinglive22.netlify.app/" : `https://kinglive22.netlify.app/${location}`,
      gameName: items.name,
    }
    fetch('https://api-sit.hithitech.com/game/launchGame', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(param)
    })
      .then(response => response.json())
      .then(responseData => {
        if (responseData.status.code === 0) {
          const res = responseData.data.url;
          setUrlIframe(res)
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setIsLaunchDemo(false);
        }
      })
  }

  const reload = () => {
    ref.current += 1;
    if (ref.current >= 2) {
      ref.current = -1;
      setIsLaunchDemo(false);
    }
  }

  const menuGame = [
    { type: "all", icon: icon_allgames },
    { type: "SLOT", icon: icon_slot },
    { type: "ARCADE", icon: icon_arcade },
    { type: "FISHING", icon: icon_fishing },
    { type: "BOARD", icon: icon_board },
    { type: "CARD", icon: icon_card },
  ];

  return (
    <WrapperGameDemo className="mx-auto m-5 w-full lg:container">
      <Header color={textColorTheme[location].color}>GAME DEMO</Header>
      <Nav
        color={textColorTheme[location].color}
        buttonTheme={ButtonTheme[location].hover.background}
      >
        <div
          className="sm:hidden lg:left-10"
          id="marker"
          style={{ left: "20px", width: "131px" }}
        >
          <div
            className="trigle"
            color={trigleTheme[location].borderbottom}
          ></div>
        </div>
        {listCate.map((items) => (
          <div key={items.type}>
            {menuGame.map((item) => (
              <div key={item.icon}>
                {items.type === item.type && (
                  <button
                    onClick={() => [onClickMenu(items.type), setIsLaunchDemo(false)]}
                    className={`${select === items.type && "-active"}`}
                  >
                    <img src={`${item.icon}`} alt="" />
                    {items.text}
                  </button>
                )}
              </div>
            ))}
          </div>
        ))}
      </Nav>
      {!isLaunchDemo && <WrapperGame color={textColorTheme[location].color} className="mt-10 grid lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-2 gap-6">
        {lazyData.map((items, index) => (
          <Fade bottom key={index}>
            <div className="block text-center cursor-pointer"
              onClick={() => openGameDemo(items)}
              onKeyDown={() => openGameDemo(items)}>
              <img src={items.image} alt="" />
              {items.name}
            </div>
          </Fade>
        ))}
      </WrapperGame>}
      {skip * perPage + perPage < renderData.length && !isLaunchDemo && (
        <WrapperButton className="cursor-pointer" onClick={load}>
          <ThemeProvider theme={ButtonTheme[location]}>
            <Button className="whitespace-nowrap">Show more</Button>
          </ThemeProvider>
        </WrapperButton>
      )}

      {isLaunchDemo && location !== 'pgslot' &&
        <WrapperGameFrame color={textColorTheme[location].color} className='mt-10'>
          <iframe src={urlIframe}
            className='p-2'
            id="iframe"
            frameBorder="0" scrolling="no"
            onLoad={reload}></iframe>
        </WrapperGameFrame>}

        {isLaunchDemo && location === 'pgslot' &&
        <WrapperGameFramePgSlot color={textColorTheme[location].color} className='mt-10'>
          <iframe src={urlIframe}
            className='p-2'
            id="iframe"
            frameBorder="0" scrolling="no"
            onLoad={reload}></iframe>
        </WrapperGameFramePgSlot>}
    </WrapperGameDemo>
  );
};

export default GameDemoComponent;
